
import { TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { separadorMillares } from "../../../../helpers";
import { LayoutTabla } from "../../../layout";



export const TablaRemesasXProducBodega = ({ data }) => {



    return (
        <LayoutTabla mb={3}>
            <TableHead>
                <TableRow>
                {(data) 
                ? (
                    data.map((r) => (
                    <TableCell key={`${r.id}-${r.cantidadDisponible}`}>
                        {r.cantidadDisponible} und
                    </TableCell>
                ))) 
                : (
                    <TableCell align="center" colSpan={1}>
                        No se encontraron cantidades definidos
                    </TableCell>
                )}
                </TableRow>
            </TableHead>

            <TableBody>
                <TableRow>
                {data 
                ? (
                    data.map((r) => (
                    <TableCell key={`${r.id}-${r.costoUnitario}`}>
                        {`$${separadorMillares(r.costoUnitario)}`}
                    </TableCell>
                ))) 
                : (
                    <TableCell align="center" colSpan={1}>
                        No hay precios disponibles para este producto en ninguna bodega
                    </TableCell>
                )}
                </TableRow>
            </TableBody>
        </LayoutTabla>
    )
}
